import * as api from "@/api/podcasts.api"
import * as PodcastService from "@/services/PodcastService"
import { notificationError } from "@/common/helpers/notifications.helper"
import { getPodcastGeoblock, getPodcastGeoblockIP } from "@/api/podcastGeoBlocking.api"

const resolveIsAiPodcast = (rootGetters) => !!rootGetters["Podcast/isAiPodcast"]

export const getPodcasts = async ({ commit }, accountKey) => {
  try {
    const podcasts = await api.getPodcasts(accountKey)
    commit("setPodcasts", podcasts)
    return podcasts
  } catch (e) {
    console.error(e)
    await notificationError("Unable to load the podcasts. Please try again.", "Failed to load podcasts")
    throw e
  }
}

export const getPodcast = async ({ commit, state, rootGetters }, podcastKey) => {
  try {
    // Prefer the type from the already-loaded podcasts list — it's the reliable
    // source when navigating between podcasts, because rootGetters["Podcast/isAiPodcast"]
    // still reflects the *previous* podcast's type at this point.
    const fromList = state.podcasts?.find((p) => p.key === podcastKey)
    const isAiPodcast = fromList ? fromList.podcast_type === "recording_with_ai" : resolveIsAiPodcast(rootGetters)

    const podcast = await PodcastService.getPodcast(podcastKey, isAiPodcast)
    commit("setPodcast", podcast)
    return podcast
  } catch (e) {
    console.error(e)
    await notificationError("Unable to load the podcast. Please try again.", "Failed to load podcast")
    throw e
  }
}

export const updatePodcast = async ({ commit, rootGetters }, data) => {
  try {
    const isAiPodcast = resolveIsAiPodcast(rootGetters)
    const podcast = await PodcastService.updatePodcast(data, isAiPodcast)
    commit("setPodcast", podcast)
    return podcast
  } catch (e) {
    console.error(e)
    throw e
  }
}

// Loads the Access rules of the open podcast. The navbar and the Access tab only summarise them and the Access cards
// report their own load errors, so a failure here leaves the summary out instead of notifying.
export const fetchAvailability = async ({ commit, state }, podcastKey) => {
  try {
    const [countries, ips] = await Promise.all([getPodcastGeoblock(podcastKey), getPodcastGeoblockIP(podcastKey)])

    // the user may have opened another podcast while this was loading
    if (state.podcast.key !== podcastKey) return

    commit("setAvailability", {
      countryRule: countries.countries?.length ? { action: countries.action, values: countries.countries } : null,
      ipRule: ips.ips?.length ? { action: ips.action, values: ips.ips } : null,
    })
  } catch (e) {
    console.error(e)
  }
}

export const resetPodcasts = ({ commit }) => {
  commit("setPodcasts", null)
}

export const resetPodcast = ({ commit }) => {
  commit("resetPodcast")
  commit("Episode/reset", [], { root: true })
}
